import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import React, { useRef, useState } from "react";
import { useClickOutside } from "../../hooks/useClickOutside";
import { C3Text } from "../text/CustomText";
import styled from "styled-components";
import DefaultDropdownMenu from "../dropdown/DefaultDropdownMenu";

const ButtonContainer = styled.div`
    position: relative;
    width: auto;
    height: auto;
`;

function CustomOptionButton({ isPrimary, dropdownValues, ...props }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const menuRef = useRef(null);
    useClickOutside(menuRef, () => {
        setIsMenuOpen(false);
    });

    if (!dropdownValues) {
        return <C3Text>dropdownValues 속성 누락</C3Text>;
    }

    const topPosition = "-240%";
    const leftPosition = "-230%";
    const openedLeftSide = true;
    const minWidth = "232px";
    const borderRadius = "8px";

    if (isPrimary) {
        return (
            <ButtonContainer ref={menuRef}>
                <PrimaryButton {...props} onClick={toggleMenu} />
                {isMenuOpen && (
                    <DefaultDropdownMenu
                        onClose={toggleMenu}
                        values={dropdownValues}
                        top={topPosition}
                        left={leftPosition}
                        openedLeftSide={openedLeftSide}
                        minWidth={minWidth}
                        borderRadius={borderRadius}
                    />
                )}
            </ButtonContainer>
        );
    }
    return (
        <ButtonContainer ref={menuRef}>
            <SecondaryButton {...props} onClick={toggleMenu} />
            {isMenuOpen && (
                <DefaultDropdownMenu
                    onClose={toggleMenu}
                    values={dropdownValues}
                    top={topPosition}
                    left={leftPosition}
                    openedLeftSide={openedLeftSide}
                    minWidth={minWidth}
                    borderRadius={borderRadius}
                />
            )}
        </ButtonContainer>
    );
}

export default CustomOptionButton;
